import { Link } from 'react-router-dom';
import { isSyncConfigured } from '../../sync/config';

export function MoreScreen() {
  return (
    <div className="screen">
      <div className="screen-title">More</div>

      <Link className="list-tap" to="/more/volume">
        <div><strong>Weekly volume + frequency</strong><div className="faint" style={{ fontSize: 12 }}>Working sets per muscle vs targets</div></div>
        <span className="chip">View</span>
      </Link>
      <Link className="list-tap" to="/more/measurements">
        <div><strong>Body measurements</strong><div className="faint" style={{ fontSize: 12 }}>Bodyweight, waist, arm, chest, thigh</div></div>
        <span className="chip">View</span>
      </Link>
      <Link className="list-tap" to="/more/settings">
        <div><strong>Sync, import & export</strong><div className="faint" style={{ fontSize: 12 }}>Notion sync, history import, CSV/Markdown</div></div>
        <span className={`chip ${isSyncConfigured() ? 'good' : ''}`}>{isSyncConfigured() ? 'Synced' : 'Offline'}</span>
      </Link>

      <div className="section-label">About</div>
      <div className="card">
        <div className="muted" style={{ fontSize: 14 }}>
          Offline-first gym tracker. Source of truth is on-device (IndexedDB); the deterministic progression engine
          runs with zero signal. Notion is an optional mirror + coaching channel.
        </div>
        <div className="faint" style={{ fontSize: 12, marginTop: 8 }}>
          Install: in your browser menu choose "Add to Home Screen" to run it full-screen and offline.
        </div>
      </div>
    </div>
  );
}
